import css from "./popUp.module.css";
import React from "react";
import { db } from "../../firebase";
import { doc, onSnapshot } from "firebase/firestore";

const DOC_ID = "subscribe_discount_popup";

const SubscribePopup = React.forwardRef(({ onClick, className }, ref) => {
  const [html, setHtml] = React.useState("");
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    const unsub = onSnapshot(doc(db, "popups", DOC_ID), (snap) => {
      setLoading(false);

      if (!snap.exists()) {
        setHtml("<p>Інформація для підписки ще не додана.</p>");
        return;
      }

      const data = snap.data();
      setHtml(
        data?.contentHtml || "<p>Інформація для підписки ще не додана.</p>",
      );
    });

    return () => unsub();
  }, []);

  return (
    <div
      className={`${css.subscribePopWrap} ${className || ""}`}
      ref={ref}
      onClick={onClick}
    >
      <div
        className={css.mainPopP}
        dangerouslySetInnerHTML={{ __html: loading ? "…" : html }}
      />
    </div>
  );
});

export default SubscribePopup;
